// extracted by mini-css-extract-plugin
export default {"root":"_3uZ1B","left":"_2nLOj","right":"_12m4K","author":"_2FAT9","actions":"pPiV_"};